<template>
  <v-container class="fill-height center-container">
    <v-card width="400" elevation="4" class="login-card">
      <v-card-title class="title-container">
        <img src="/logo.png" alt="Logo" class="logo-image" />
      </v-card-title>
      <v-card-title class="system-title">數發部管理系統</v-card-title>
      <v-card-title class="login-title">登入</v-card-title>

      <!-- 登入表單 -->
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field v-model="email" label="帳號" type="text" outlined required></v-text-field>
          <v-text-field v-model="password" label="密碼" type="password" outlined required></v-text-field>
        </v-form>
      </v-card-text>

      <!-- 錯誤訊息 -->
      <v-card-text v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </v-card-text>



      <!-- 按鈕區 -->
      <v-card-actions>
        <v-btn class="login-btn" block @click="login">
          登入
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- 登入成功彈窗 -->
    <v-dialog v-model="dialogVisible" max-width="300">
      <v-card>
        <v-card-title class="dialog-title">登入成功</v-card-title>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      valid: true,
      errorMessage: "", // 錯誤訊息
      dialogVisible: false, // 控制彈窗顯示
    };
  },
  methods: {
    async login() {
      const baseUrl = process.env.VUE_APP_BASE_URL || `${process.env.VUE_APP_SERVICE_URL}/api/v1`;

      const payload = {
        account: this.email,
        password: this.password,
      };

      try {
        const headers = {
          "Content-Type": "application/json",
        };

        // 發送登入請求
        const response = await axios.post(`${baseUrl}/backend-users/login`, payload, { headers });

        if (response.data.rtnCode === "0000") {
          const token = response.data.data.token;
          const userData = response.data.data.userData;

          // 儲存至 localStorage
          localStorage.setItem("authToken", token);
          localStorage.setItem("backendUserAccount", userData.backendUserAccount);
          localStorage.setItem("accountStatus", userData.accountStatus);
          localStorage.setItem("email", userData.email);
          localStorage.setItem("lastTimeLogin", userData.lastTimeLogin);
          localStorage.setItem("permissions", JSON.stringify(userData.permissions));

          // 顯示成功訊息並跳轉
          this.errorMessage = "";
          this.dialogVisible = true;

          setTimeout(() => {
            this.dialogVisible = false;
            this.$router.push("/tools"); // 成功後跳轉
          }, 1000);
        } else {
          this.errorMessage = response.data.rtnMsg || "登入失敗，請檢查帳號和密碼。";
        }
      } catch (error) {
        console.error("API Error:", error.response || error.message);
        this.errorMessage = error.response?.data?.rtnMsg || "伺服器錯誤，請稍後再試。";
      }
      console.log(localStorage.getItem("authToken"));
      console.log(localStorage.getItem("backendUserAccount"));
      console.log(localStorage.getItem("accountStatus"));
      console.log(localStorage.getItem("email"));
      console.log(localStorage.getItem("lastTimeLogin"));
      console.log(localStorage.getItem("permissions"));

    }

    ,
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
  background-color: #f5f5f5;
}

.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  text-align: center;
  padding-top: 20px;
  border-radius: 12px;
}

.logo-image {
  max-height: 60px;
  margin-bottom: 16px;
}

.system-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.login-title {
  font-size: 16px;
  font-weight: normal;
  color: #333333;
  margin-bottom: 16px;
}

.hint-text {
  margin-top: 16px;
  font-size: 14px;
  color: #777777;
  text-align: left;
}

.error-message {
  color: #ff5252;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}

.dialog-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #4caf50;
  /* 綠色標題 */
}

.login-btn {
  background-color: #000000;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
}

.login-btn:hover {
  background-color: #333333;
  color: #ffffff;
}
</style>
